package com.ilussobsa.views

import com.ilussobsa.*
import com.ilussobsa.sdk.currentSession
import com.ilussobsa.utils.pastAuctions
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.locale.RenderSize
import com.lightningkite.kiteui.locale.renderDateToString
import com.lightningkite.kiteui.models.*
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.children
import com.lightningkite.kiteui.views.l2.icon
import com.lightningkite.lightningdb.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import com.lightningkite.serialization.notNull

@Routable("/past-auctions")
class PastAuctionsScreen : Page {

    override fun ViewWriter.render() = col {
        card - expanding  - col {
            row {
                centered - icon(Icon.pastAuctions, "Past Auctions")
                centered - bold - h2("Past Auctions")
            }

            val pastToListen = remember {
                currentSession.awaitNotNull().vehicle.query(Query<Vehicle>(
                    orderBy = sort { it.completion.notNull.at.descending() },
                ) {
                    it.completion neq null
                })
            }
            val pastItems = remember { pastToListen()().sortedByDescending { it.completion?.at } }
//                    forEachUpdating(
//                        remember { pastItems().toList() }
//                    ) {
//
//                    }
            expanding - frame {
                recyclerView {
                    children(
                        items = pastItems,
                        id = { it._id }
                    ) {
                        col {
                            row {
                                centered  - h4 {
                                    ::content{
                                        it().mmt
                                    }
                                }
                                expanding - space()
                                centered - text {
                                    ::content{
                                        Strings.date + it().completion?.at?.renderDateToString(
                                            RenderSize.Numerical
                                        )
                                    }
                                }
                            }
                            sizedBox(SizeConstraints(height = 12.rem)) - row {
                                weight(1f) - col {
                                     image {
                                        scaleType = ImageScaleType.Crop
                                        ::source { it().thumbnail?.let { ImageRemote(it.location) } }
                                    }
                                }
                                weight(3f) - col {
                                    important - expanding - row {
                                        centered - CriticalSemantic.onNext - centered - text(Strings.bids2)
                                        expanding - space()
                                        centered - CriticalSemantic.onNext - centered - h3 { ::content{ it().completion?.bids.toString() } }
                                    }
                                    important - expanding - row {
                                        centered - CriticalSemantic.onNext - centered - text(Strings.startingBid)
                                        expanding - space()
                                        centered - bold - CriticalSemantic.onNext - h3 {
                                            ::content{
                                                it().completion?.startingBid?.renderKPriceInDollars() ?: "-"
                                            }
                                        }
                                    }
                                    important - expanding - row {
                                        centered - centered - CriticalSemantic.onNext - text(Strings.finalBid)
                                        expanding - space()
                                        centered - bold - CriticalSemantic.onNext - h3 {
                                            ::content{
                                                it().completion?.price?.renderKPriceInDollars() ?: "-"
                                            }
                                        }
                                    }
                                }
                            }
                            separator()
                            space()
                        }
                    }
                }
            }
        }
    }
}
